import { BiBuilding } from "react-icons/bi";
import { BsTag } from "react-icons/bs";
import { FiSettings } from "react-icons/fi";
import { HiOutlineKey } from "react-icons/hi";
import { MdArrowBackIos } from "react-icons/md";
import { doesLoggedinUserHavePermission } from "../../util/SiteUtil";
import { PERMISSIONS, USER_ROLES } from "../../util/Type";
import { SideBarOptionsType } from "../commoncomponents/sidenavbar/Util";

export const managePropertyTabOption = (id: string) => [
    {
        label: 'Portfolio',
        url: '/portfolio',
    },
    {
        label: 'Manage Site',
        url: `/site/${id}/info`,
    },
    {
        label: 'Manage Property',
    },
];

export const SiteManageProperty = (id: string, role: string): SideBarOptionsType[] => [
    {
        id: 1,
        label: 'Manage Site',
        url: `/site/${id}/info`,
        icons: <MdArrowBackIos fontSize={"30px"} />,
        isAvailaible: true
    },
    ...manageSiteOptions(id, role)
];

export const manageSiteOptions = (id: string, role: string) => [
    {
        id: 2,
        label: 'Manage Properties',
        url: `/site/${id}/manageproperties`,
        icons: <BiBuilding fontSize={"30px"} />,
        isSelected: true,
        isAvailaible: true
    },
    {
        id: 3,
        label: 'Site Services',
        url: `/site/${id}/services`,
        icons: <BsTag fontSize={"30px"} />,
        isAvailaible: doesLoggedinUserHavePermission(role, USER_ROLES.SERVICE_FOR_SITE, PERMISSIONS.VIEW)
    },
    {
        id: 4,
        label: 'Site Settings',
        url: `/site/${id}/settings`,
        icons: <FiSettings fontSize={"30px"} />,
        isAvailaible: doesLoggedinUserHavePermission(role, USER_ROLES.SITE_SETTINGS, PERMISSIONS.VIEW)
    },
    {
        id: 5,
        label: 'Shared Services',
        url: `/site/${id}/sharedservices`,
        icons: <HiOutlineKey fontSize={"30px"} />,
        isAvailaible: doesLoggedinUserHavePermission(role, USER_ROLES.SHARED_SERVICE, PERMISSIONS.VIEW)
    },
];
